const createHeaders = () => {

  var headers =[
    {label:'שם', key:'firstname'},
    {label:'שם משפחה', key:'lastname'},
    {label:'מייל', key:'mail'},
    {label:'טלפון', key:'phone'},
    {label:'סטטוס', key:'status'},
    {label:'טאגים', key:'intrestedIn'},
    {label:'תאריך כניסה', key:'dateEnterSystem'},
    {label:'שינוי אחרון', key:'lastChange'},
    {label:'תאריך היסטוריה אחרונה', key:'LastHistoryDateTime'},
    {label:'היסטוריה אחרונה', key:'LastHistoryVal'},
    {label:'תקשורת אחרונה', key:'lastconnected'},
    {label:'גיל', key:'age'},
    {label:'מין', key:'sex'}
  ]
  return headers;
};
export default createHeaders;
